import TransactionSuccessToast from '~/components/ui/molecule/TransactionSuccessToast.vue';
import Vue from 'vue';
import TransactionPendingToast from '~/components/ui/molecule/TransactionPendingToast.vue';

export default function ({ $toast, $isMobileResponsive, app, store }, inject) {
  const notify = {
    success(
      msg = 'Success !',
      options = {
        className: ['toasted-success'],
        duration: 2500,
        closeOnSwipe: false,
        showCloseButton: true,
        position: $isMobileResponsive ? 'bottom-center' : 'top-right',
      }
    ) {
      const successMsg = `<div style="display: flex; justify-content: space-between; width: -webkit-fill-available; align-items: center;">${msg} <span style="font-size: 18px;" onclick="this.closest('.toasted').remove()">&#10005;</span></div>`;
      $toast.success(successMsg, {
        ...options,
        icon: 'done',
      });
    },
    addTransactionSuccess(
      msg = 'Success !',
      profileId,
      options = {},
      transactionData
    ) {
      const ToastComponent = Vue.extend(TransactionSuccessToast);
      const component = new ToastComponent({
        propsData: { msg },
        i18n: app.i18n,
      });
      component.$mount();

      component.$on('share', () => {
        store.dispatch('modals/showCreatePostModal', {
          target: profileId,
          targetType: 'PROFILE',
          transactionData: transactionData,
        });
        $toast.clear();
      });

      component.$on('close', () => {
        component.$destroy();
        $toast.clear();
      });

      $toast.success(component.$el, {
        className: ['toasted-transaction-success'],
        duration: 5000,
        position: $isMobileResponsive ? 'bottom-center' : 'top-right',
        icon: false,
        ...options,
      });
    },
    addTransactionPending(msg = 'Transaction pending...', options = {}) {
      const ToastComponent = Vue.extend(TransactionPendingToast);
      const component = new ToastComponent({
        propsData: { msg },
        i18n: app.i18n,
      });
      component.$mount();

      component.$on('close', () => {
        component.$destroy();
        $toast.clear();
      });

      $toast.info(component.$el, {
        className: ['toasted-transaction-pending'],
        duration: 2500,
        position: $isMobileResponsive ? 'bottom-center' : 'top-right',
        icon: false,
        ...options,
      });
    },
    error(
      msg = 'Error !',
      options = {
        className: ['toasted-error'],
        duration: 2500,
        closeOnSwipe: false,
        showCloseButton: true,
        position: $isMobileResponsive ? 'bottom-center' : 'top-right',
      }
    ) {
      const errorMsg = `<div style="display: flex; justify-content: space-between; width: -webkit-fill-available; align-items: center;">${msg} <span style="font-size: 18px;" onclick="this.closest('.toasted').remove()">&#10005;</span></div>`;

      $toast.error(errorMsg, { ...options, icon: 'info_outlined' });
    },

    info(
      msg = 'Info !',
      options = {
        className: ['toasted-info'],
        duration: 2500,
        closeOnSwipe: false,
        showCloseButton: true,
      }
    ) {
      const infoMsg = `<div style="display: flex; justify-content: space-between; width: -webkit-fill-available; align-items: center; color: #f0f0f0">${msg} <span style="font-size: 18px; color=#fFfFfF"  onclick="this.closest('.toasted').remove()">&#10005;</span></div>`;
      $toast.info(infoMsg, { ...options, icon: 'info_outlined' });
    },
    warning(
      msg = 'Warning !',
      options = {
        className: ['toasted-warning'],
        duration: 2500,
        closeOnSwipe: false,
        showCloseButton: true,
      }
    ) {
      $toast.warning(msg, { ...options, icon: 'info_outlined' });
    },
  };

  // Inject to context as $api
  inject('notify', notify);
}
